
/* eslint-disable react-hooks/exhaustive-deps */
import { useFormContext, useWatch } from "react-hook-form"
import { FormInvoiceType } from "../types"
import { useInvoiceCode } from "../utils/hooks"

export const CodeInvoice = ({ isEdit }: { isEdit: boolean }) => {
  const { control, setValue, formState } = useFormContext<FormInvoiceType>()
  const [transaction_date, trx_code] = useWatch({
    control,
    name: ["transaction_date", "trx_code"]
  })

  useInvoiceCode({
    key: formState.submitCount,
    type: "next_code",
    trx_date: transaction_date,
    onSuccess: (data) => {
      setValue("trx_code", data)
      setValue("referensi", data)
    },
    enabled: !isEdit && Boolean(transaction_date)
  })

  return <div>{trx_code}</div>
}
